export default __webpack_public_path__ + "static/media/warning--roundabout--g5.ac2266ff.png";